import { useEffect } from "react"
import { useNavigate, useParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useGetExamResult = () => {
    const navigate = useNavigate()
    const { idx } = useParams()

    const [fetchResult, fetchRequest] = useFetch()
    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        fetchRequest("GET", `/tryout/payment/${idx}/result`)
    }, [])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 400:
                if (fetchResult?.data?.error_code === "payment_idx") setAlert("결제 idx 입력 양식을 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
            case 403:
                if (fetchResult?.data?.error_code === 1) {
                    setAlert("아직 응시를 하지 않았습니다.")
                    navigate("/my/tryout/record")
                }
                break
            case 404:
                if (fetchResult?.data?.error_code === 1) {
                    setAlert("존재하지 않는 결제 이거나 접근 권한이 없습니다.")
                    navigate("/my/tryout/record")
                }
                break
        }
    }, [fetchResult])

    return [fetchResult]
}

export default useGetExamResult